import React, {useState} from 'react'
import {css} from '@emotion/core'

const ChevronIcon = ({isExpanded, color}) => (
    <svg
        css={css`
            width: 28px;
            height: 28px;
            flex-shrink: 0;
            transform: ${isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
            transition: transform 200ms ease;
        `}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M6 9L12 15L18 9" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const AboutFaqItem = ({item, themeStyles}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const hasAnswer = Boolean(item.answer && item.answer.trim().length > 0)
    const textColor = themeStyles.about.valuePropTextColor
    const cardBackground = themeStyles.about.faqCardBackground

    return (
        <div
            css={css`
                width: 100%;
                background: ${cardBackground};
                border-radius: 28px;
                overflow: hidden;
                padding: 24px;
                p {
                    margin: 12px 0 0;
                    font-size: 18px;
                    line-height: 28px;
                    color: ${textColor};
                    width: 90%;
                    a {
                        color: ${themeStyles.about.cta4Color};
                        transition: color 150ms ease;
                        &:hover {
                            color: ${themeStyles.brandBlue};
                        }
                    }
                    ul {
                        margin: 0;
                        padding-left: 27px;
                        li,
                        b {
                            color: ${textColor};
                        }
                    }
                }
                @media (${themeStyles.breakPoints.mobile}) {
                    padding: 24px 20px;
                }
            `}
        >
            <button
                type="button"
                onClick={() => setIsExpanded((prevValue) => !prevValue)}
                aria-expanded={isExpanded}
                css={css`
                    width: 100%;
                    border: 0;
                    background: transparent;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 24px;
                    text-align: left;
                    cursor: pointer;
                    padding: 0;
                `}
            >
                <span
                    css={css`
                        font-size: 20px;
                        font-weight: 700;
                        line-height: 28px;
                        width: 580px;
                        color: ${textColor};
                    `}
                >
                    {item.question}
                </span>
                <ChevronIcon
                    css={css`
                        height: 24px;
                        width: 24px;
                        min-width: 24px;
                    `}
                    isExpanded={isExpanded}
                    color={textColor}
                />
            </button>
            {isExpanded && hasAnswer && (
                // eslint-disable-next-line react/no-danger
                <p dangerouslySetInnerHTML={{__html: item.answer}} />
            )}
        </div>
    )
}

export default AboutFaqItem
